/* eslint-disable import/no-named-as-default */
import angular from 'angular';

import LocalStorageService from './local-storage.service';
import NotificationService from './notification.service';
import ServiceWorkerService from './service-worker.service';
import BrowserStatisticsService from './statistics.service';
import TabService from './tab.service';

export default angular.module('autoboard.browser', [BrowserStatisticsService,
  LocalStorageService, NotificationService, ServiceWorkerService, TabService])
  .name;
